import { render, staticRenderFns } from "./download-app.vue?vue&type=template&id=ea4001da&scoped=true&"
import script from "./download-app.vue?vue&type=script&lang=js&"
export * from "./download-app.vue?vue&type=script&lang=js&"
import style0 from "./download-app.vue?vue&type=style&index=0&id=ea4001da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4001da",
  null
  
)

export default component.exports